import { Grid, Icon, ListItemIcon, ListItemText } from "@mui/material";

import Card from "@mui/material/Card";

import SoftTypography from "components/SoftTypography";
import { useCardroomContext } from "features";
import { useState } from "react";

import AgentFeeSelector from "layouts/Club/components/AgentFees/Selector";
import FeeScheduleEditor from "layouts/Club/components/AgentFees/Editor";


const ClubFeesEditor = ({ cardroom, club }) => {

    const [context, actions, features] = useCardroomContext(cardroom);

    function canEditSchedule() {
        if (!context) return false;

        return context.isAllowed(actions.cardroom.fees.agent.edit);
    }

    const addSchedulePlaceHolder = canEditSchedule() ? { id: null, name: "New Schedule" } : null;

    const [currentFeeSchedule, setCurrentFeeSchedule] = useState(null);
    const [reloadSchedulesNeeded, setReloadSchedulesNeeded] = useState(false);

    function onFeeScheduleChanged(item) {
        setReloadSchedulesNeeded(false);
        setCurrentFeeSchedule(item);
    }

    function onScheduleEditDone(canceled) {
        setCurrentFeeSchedule(null);
        setReloadSchedulesNeeded(true);
    }

    function buildListItem(item) {
        if (item.id) {
            return <ListItemText><SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize">
                {item.name}
            </SoftTypography></ListItemText>;
        }
        else {
            return <>
                <ListItemIcon style={{ minWidth: "32px" }}>
                    <Icon>add</Icon>
                </ListItemIcon>
                <ListItemText><SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize">
                    {item.name}
                </SoftTypography></ListItemText></>;
        }
    }

    return <Grid width="100%" xs={12}>
        <Grid container xs={12}>
            <Grid item xs={4} p={2}>
                <AgentFeeSelector cardroom={cardroom} club={club} emptyValue={addSchedulePlaceHolder}
                    onSelectionChanged={onFeeScheduleChanged} onBuildListItem={buildListItem} type="list" reload={reloadSchedulesNeeded} maxHeight="375px" />
            </Grid>
            <Grid item xs={8}> <Card style={{ overflow: "auto" }}>
                {currentFeeSchedule ?
                    <FeeScheduleEditor cardroom={cardroom} club={club} schedule={currentFeeSchedule} dense={true} onClose={onScheduleEditDone} />
                    :
                    <Card sx={{ height: 375 }}>
                        <Grid container xs={12} justifyContent="center" alignItems="center">
                            <Grid item xs={12} textAlign={"center"}>

                                <SoftTypography
                                    component="h5"
                                    variant="caption"
                                    color="info">
                                    Select agent commission fee schedule from the list or tap "add new" to create a new schedule
                                </SoftTypography>

                            </Grid>
                        </Grid>
                    </Card>
                }</Card>
            </Grid>
        </Grid>
    </Grid>;
};

export default ClubFeesEditor;